import { getValue, getValueOrDefault } from '../../components/values/Get';
import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { CustomPageValidatorFn } from '../../types/custom-page-validator';

const validateScenarioOne = (formConfig: FormConfig, formValues: FormValues): boolean => {
    const damageToPerson = getValue(formConfig, formValues, 'whichPersonsWereInjured1');
    const damageToVehicle = getValue(formConfig, formValues, 'whichVehiclesWereDamaged1');
    const damageToOther = getValue(formConfig, formValues, 'whichOtherStuffWasDamaged1');

    // Check if at least 1 option is checked
    if (
        (damageToPerson && damageToPerson.length) ||
        (damageToVehicle && damageToVehicle.length) ||
        (damageToOther && damageToOther.length)
    ) {
        return true;
    }

    return false;
};

const validateScenarioTwo = (formConfig: FormConfig, formValues: FormValues): boolean => {
    const damageToPerson1 = getValue(formConfig, formValues, 'whichPersonsWereInjured');
    const damageToVehicle1 = getValue(formConfig, formValues, 'whichVehiclesWereDamaged');
    const damageToOther1 = getValue(formConfig, formValues, 'whichOtherStuffWasDamaged');

    // Check if any of the checkboxes are marked
    if (
        (damageToPerson1 && damageToPerson1.length) ||
        (damageToVehicle1 && damageToVehicle1.length) ||
        (damageToOther1 && damageToOther1.length)
    ) {
        return true;
    }

    return false;
};

export const customPageValidation: CustomPageValidatorFn = (
    formValues: FormValues | undefined,
    formConfig: FormConfig | undefined
): boolean => {
    if (!formValues || !formConfig) {
        return false;
    }

    const selectedValue = getValueOrDefault(
        formConfig,
        formValues,
        'whichStatementMostAccuratelyDescribesTheSituation'
    );
    switch (selectedValue.value) {
        case 'iBrakedBecauseIThereWasATrafficLIght':
        case 'iBrakedBecauseOfAQueue':
        case 'iBrakedBecauseIHadToTurn':
            return validateScenarioOne(formConfig, formValues);

        case 'myCarHalted':
        case 'noneOfTheAbove':
            return validateScenarioTwo(formConfig, formValues);

        default:
            return false;
    }
};
